import { Fragment, memo, useMemo } from 'react';
import {
  TableDomesticPartnershipBodyVM,
  TableDomesticPartnershipVM,
} from 'practice/view-models/practice-edit-residence';
import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import Table from 'shell/components/shared/table';
import { headCells } from '../constant';
import { noop } from 'shell/utils/noop';
import { FormActualResidenceVM } from 'practice/view-models/pratice-actual-residence';
import { transformActualResidencePractice } from 'practice/utils/transform-residence-vm';

interface TableDomesticProps {
  disabled?: boolean;
  tableDomesticPartnership?: TableDomesticPartnershipVM;
  onChangeTableDomesticPartnership: (table: TableDomesticPartnershipVM) => void;
}

const TableDomesticComponent = ({
  disabled,
  onChangeTableDomesticPartnership,
  tableDomesticPartnership,
}: TableDomesticProps): React.ReactElement => {
  const onChange = useEventCallback(
    (
      key: keyof TableDomesticPartnershipVM,
      value: TableDomesticPartnershipVM[keyof TableDomesticPartnershipVM]
    ) => {
      onChangeTableDomesticPartnership({
        ...(tableDomesticPartnership || {}),
        [key]: value,
      });
    }
  );

  const onChangeValues = useEventCallback((values: TableDomesticPartnershipVM) => {
    onChangeTableDomesticPartnership({
      ...(tableDomesticPartnership || {}),
      ...values,
    });
  });

  const onChangePage = useEventCallback((page: number) => {
    onChange('page', page);
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    onChangeTableDomesticPartnership({
      ...(tableDomesticPartnership || {}),
      page: 0,
      rowsPerPage,
    });
  });

  const onDetailPress = useEventCallback((item: TableDomesticPartnershipBodyVM) => {
    const residence: FormActualResidenceVM = transformActualResidencePractice(item.residence);

    onChangeValues({
      body:
        tableDomesticPartnership?.body?.map((familiar) =>
          familiar.IdCardMunicipality === item.IdCardMunicipality
            ? { ...familiar, isActive: !familiar.isActive }
            : { ...familiar, isActive: false }
        ) || [],
      residence,
      item: item.isActive ? null : item,
    });
  });

  const body: Array<TableDomesticPartnershipBodyVM> = useMemo(() => {
    if (!tableDomesticPartnership?.body?.length) {
      return [];
    }

    return tableDomesticPartnership?.body?.map((item, index) => ({
      ...item,
      action: (
        <FormControlLabel
          control={
            <Checkbox
              id={`${item.IdCardMunicipality}-${index}-checkbox`}
              name={`${item.IdCardMunicipality}-${index}-checkbox`}
              checked={item.isActive || false}
              onChange={() => onDetailPress(item)}
              disabled={disabled}
            />
          }
          label=""
        />
      ),
    }));
  }, [tableDomesticPartnership?.body]);

  return (
    <Fragment>
      {body.length > 0 ? (
        <Grid item xs={12}>
          <Table
            ariaLabel="Lista convivenza"
            page={tableDomesticPartnership?.page || 0}
            rowsPerPage={tableDomesticPartnership?.rowsPerPage}
            body={body}
            count={body.length}
            head={headCells}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
            orders={{}}
            isNotLayoutFixed
            noSort
            onSort={noop}
            hideButtons
          />
        </Grid>
      ) : undefined}
    </Fragment>
  );
};

TableDomesticComponent.displayName = 'Table Domestic';

const TableDomestic = memo(TableDomesticComponent) as typeof TableDomesticComponent;

export default TableDomestic;
